import { render, staticRenderFns } from "./EventDetailsImageDialog.vue?vue&type=template&id=545d445d&scoped=true"
import script from "./EventDetailsImageDialog.vue?vue&type=script&lang=js"
export * from "./EventDetailsImageDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsImageDialog.vue?vue&type=style&index=0&id=545d445d&prod&lang=scss"
import style1 from "./EventDetailsImageDialog.vue?vue&type=style&index=1&id=545d445d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d445d",
  null
  
)

export default component.exports